export default "__VITE_ASSET__Bqe4Q1y7__"